import RecentInteractions from './RecentInteractions';

export default RecentInteractions;
